import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {PromotionDetail} from "../types/PromotionDetail";

interface IParams {
    promotions: PromotionDetail[];
    offerId: number;
    propertyId?: number;
    applicationSource: ApplicationSource;
    ctaText: string;
}

export const getAmplitudePromotionsLeadFormTrackingContext = (params: IParams): IAmplitudeLeadFormTrackingContext => {
    const {promotions, offerId, propertyId, applicationSource, ctaText} = params;
    const location = propertyId != null ? "property_page" : "investment_page";

    return {
        inquiry_source: location,
        cta_text: ctaText,
        form_location: location,
        source_id: applicationSource,
        lead_type: "single_lead",
        item_id: offerId,
        ...(propertyId != null && {property_id: propertyId}),
        promotion_id: promotions.map((promotion) => promotion.id),
        promotion_name: promotions.map((promotion) => promotion.name),
        creative_name: "Promocje",
        promotion_content: promotions.map((promotion) => promotion.description ?? "brak opisu")
    };
};
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {PromotionDetail} from "../types/PromotionDetail";

interface IParams {
    promotions: PromotionDetail[];
    offerId: number;
    propertyId?: number;
    applicationSource: ApplicationSource;
    ctaText: string;
}

export const getAmplitudePromotionsLeadFormTrackingContext = (params: IParams): IAmplitudeLeadFormTrackingContext => {
    const {promotions, offerId, propertyId, applicationSource, ctaText} = params;
    const location = propertyId != null ? "property_page" : "investment_page";

    return {
        inquiry_source: location,
        cta_text: ctaText,
        form_location: location,
        source_id: applicationSource,
        lead_type: "single_lead",
        item_id: offerId,
        ...(propertyId != null && {property_id: propertyId}),
        promotion_id: promotions.map((promotion) => promotion.id),
        promotion_name: promotions.map((promotion) => promotion.name),
        creative_name: "Promocje",
        promotion_content: promotions.map((promotion) => promotion.description ?? "brak opisu")
    };
};
